import script from "./SampleWorkFormDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./SampleWorkFormDialog.vue?vue&type=script&setup=true&lang=js"

import "./SampleWorkFormDialog.vue?vue&type=style&index=0&id=6b3428a5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b3428a5"]])

export default __exports__